//  names of clusters
const MARKETING = "marketing";
const CRM = "crm";
const NON_PROFIT = "ngo";

const DEFAULT = "default"; // no cluster
const GENERIC_CLUSTER = "generic";

//  events where you get clusters
const HP_TAGS_SELECTION = "hp_tags_selection";

module.exports = {
  MARKETING,
  CRM,
  DEFAULT,
  GENERIC_CLUSTER,
  HP_TAGS_SELECTION,
  NON_PROFIT
};
